var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChronoLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "164.7px",
    height: "47px",
    viewBox: "0 0 164.7 47",
    style: {
      enableBackground: "new 0 0 164.7 47"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#41A528;}\n\t.st1{fill:#4B4B4B;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.6,39.2c0,4.1-3.3,7.4-7.4,7.4H8c-4.1,0-7.4-3.3-7.4-7.4V7.9c0-4.1,3.3-7.4,7.4-7.4h31.3 c4.1,0,7.4,3.3,7.4,7.4C46.6,7.9,46.6,39.2,46.6,39.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.8,37.7c-4.5,0-8.8-3.2-8.8-10.5s4.4-10.4,8.8-10.4c2.2,0,3.9,0.6,5.1,1.4l-1.3,2.9c-0.8-0.6-2.1-1-3.3-1 c-2.7,0-5.1,2.1-5.1,7c0,4.9,2.5,7.1,5.1,7.1c1.2,0,2.5-0.4,3.3-1l1.3,3C66.7,37.1,65,37.7,62.8,37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.7,37.3V23.9c0-2.6-1.6-3.8-4.3-3.8c-1.2,0-2.6,0.4-3.6,0.9v16.3h-4.1V8h4.1v9.9c1.2-0.6,2.9-1.1,4.5-1.1 c4.7,0,7.5,2.4,7.5,6.7v13.7L83.7,37.3L83.7,37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.1,20.3c-0.6-0.1-1.3-0.2-2.1-0.2c-1.2,0-2.4,0.2-3.2,0.5v16.7h-4.1V18.2c1.9-0.8,4.8-1.4,7.8-1.4 c0.9,0,1.7,0,2.3,0.1L102.1,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.9,37.7c-5.7,0-8.8-4.5-8.8-10.5s3.1-10.4,8.8-10.4c5.7,0,8.8,4.5,8.8,10.4 C121.7,33.2,118.6,37.7,112.9,37.7z M112.9,20c-3.2,0-4.7,2.8-4.7,7.2c0,4.3,1.6,7.2,4.7,7.2c3.2,0,4.7-2.9,4.7-7.2 C117.6,22.8,116.1,20,112.9,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138,37.3V23.8c0-2.3-1.4-3.8-4.2-3.8c-1.5,0-2.9,0.3-3.7,0.6v16.6H126V18.2c2-0.8,4.6-1.4,7.7-1.4 c5.6,0,8.4,2.5,8.4,6.7v13.8H138L138,37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.1,37.7c-5.7,0-8.8-4.5-8.8-10.5s3.1-10.4,8.8-10.4s8.8,4.5,8.8,10.4S160.8,37.7,155.1,37.7z M155.1,20 c-3.2,0-4.7,2.8-4.7,7.2c0,4.3,1.6,7.2,4.7,7.2s4.7-2.9,4.7-7.2C159.9,22.8,158.3,20,155.1,20z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.3,37.9c-6.3,0-9.9-3.9-9.9-10.3c0-6.2,3.3-10.5,9.4-10.5c1.2,0,2.6,0.3,3.3,0.5V8.1h4.1v28.4 C23.9,37.2,21.2,37.9,18.3,37.9z M21.1,20.7c-0.5-0.2-1.8-0.4-2.9-0.4c-3.7,0-5.7,3.1-5.7,7.3c0,4.4,2,7.1,5.7,7.1 c1.1,0,2.4-0.3,2.9-0.5V20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.6,20.5c-0.6-0.2-1.3-0.2-2.1-0.2c-1.2,0-2.4,0.2-3.2,0.5v16.8h-4.1V18.3c1.9-0.8,4.8-1.4,7.8-1.4 c0.9,0,1.7,0,2.3,0.1L39.6,20.5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChronoLogo);
export default __webpack_public_path__ + "static/media/chrono-logo.bd1abcb387f088f9bddf4c23103b034d.svg";
export { ForwardRef as ReactComponent };